import { useCallback, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import AgeGate from "@/components/site/AgeGate";
import ResponsibleGamblingBanner from "@/components/site/ResponsibleGamblingBanner";
import CookieBanner from "@/components/site/CookieBanner";
import Hero from "@/components/site/Hero";
import PrimeDayBanner from "@/components/site/PrimeDayBanner";
import MatchbookCarousel from "@/components/site/MatchbookCarousel";
import TextBanner from "@/components/site/TextBanner";
import FloatingAffiliateCTA from "@/components/site/FloatingAffiliateCTA";
import NewsStrip from "@/components/site/NewsStrip";
import InstallPrompt from "@/components/site/InstallPrompt";
import QuickLinks from "@/components/site/QuickLinks";
import OfferWall from "@/components/site/OfferWall";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  const [profile, setProfile] = useState(null);
  const [offers, setOffers] = useState([]);
  const [links, setLinks] = useState([]);
  const [activeBanner, setActiveBanner] = useState(null);
  const [dbBanners, setDbBanners] = useState([]);

  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data)).catch(() => {});
    api.get("/offers").then((r) => setOffers(r.data)).catch(() => {});
    api.get("/links").then((r) => setLinks(r.data)).catch(() => {});
    api.get("/banners").then((r) => setDbBanners(r.data)).catch(() => {});
    // Fire a single pageview ping per HomePage mount (visitor analytics).
    api.post("/track/pageview", { path: "/" }).catch(() => {});
  }, []);

  const matchbookBanners = useMemo(
    () =>
      dbBanners.map((b) => ({
        id: b.banner_id,
        clickUrl: b.click_url,
        imgUrl: b.img_url || null,
        impressionUrl: b.impression_url || null,
        alt: b.alt || "Featured UK bookmaker offer",
        ctaLabel: b.cta_label || "Free Bet",
        customNode: b.banner_type === "text" ? <TextBanner banner={b} /> : null,
      })),
    [dbBanners]
  );

  const handleActiveChange = useCallback((banner) => setActiveBanner(banner), []);

  return (
    <div data-testid="home-page" className="relative min-h-screen" style={{ paddingBottom: "60px" }}>
      <AgeGate />
      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6">
        <Hero profile={profile} />
        <MatchbookCarousel
          testId="matchbook-carousel-top"
          label="Featured Partner"
          intervalMs={3000}
          banners={matchbookBanners}
          onActiveChange={handleActiveChange}
        />
        <PrimeDayBanner />
        <OfferWall offers={offers} compact />
        <NewsStrip />
        <OfferWall offers={offers} />
        <QuickLinks links={links} />
        <Footer />
      </div>
      <CookieBanner />
      <ResponsibleGamblingBanner />
      <FloatingAffiliateCTA activeBanner={activeBanner} />
      <InstallPrompt />
    </div>
  );
}
